import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, Observable } from '../common';
import { AppConstants } from '../common/constants';
import { IRole, IUser } from '../models';
import { BaseResponse, IPermissionsResponse, IUserResponse, IUsersResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private httpClient: HttpClient) { }

  Store(_user: IUser): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/Store`;
    
    return this.httpClient.post<BaseResponse>(url, _user, { headers });
  }

  Update(_user: IUser): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/Put`;
    
    return this.httpClient.post<BaseResponse>(url, _user, { headers });
  }

  Get(): Observable<IUsersResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/Get`;
    
    return this.httpClient.get<IUsersResponse>(url, { headers });
  }

  GetUser(_id: number): Observable<IUserResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/GetUser?id=${_id}`;
    
    return this.httpClient.get<IUserResponse>(url, { headers });
  }

  GetRole(_userId: string): Observable<IPermissionsResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/GetPermissions?userId=${_userId}`;
    
    return this.httpClient.get<IPermissionsResponse>(url, { headers });
  }

  PutByRole(_IdRole: number, _roles: IRole[]): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/PutByUser`;
    
    return this.httpClient.post<BaseResponse>(url, {
      'IdUser': _IdRole,
      'Roles': _roles
    }, { headers });
  }
}

